export enum GrantAIAgentStatus {
  DOCUMENT_RUNNER_INITIATED = 'DOCUMENT_RUNNER_INITIATED',
  DOCUMENT_RUNNER_STARTED = 'DOCUMENT_RUNNER_STARTED',
  PROPERTY_CARD_COLLECTING = 'PROPERTY_CARD_COLLECTING',
  TAX_DOCUMENT_COLLECTING = 'TAX_DOCUMENT_COLLECTING',
  BOOKS_AND_PAGE_FOUND = 'BOOKS_AND_PAGE_FOUND',
  DEEDS_COLLECTING = 'DEEDS_COLLECTING',
  DEEDS_COLLECTED = 'DEEDS_COLLECTED',
  PROPERTY_CARD_PROCESSING = 'PROPERTY_CARD_PROCESSING',
  TAX_INFO_PROCESSING = 'TAX_INFO_PROCESSING',
  DEED_PROCESSING = 'DEED_PROCESSING',
  OPERATION_COMPLETED = 'OPERATION_COMPLETED',
  ERROR = 'ERROR',
  NOT_FOUND = 'NOT_FOUND'
}